import { styled, SxProps } from "@mui/material";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";

export const StyledContentEditable = styled(ContentEditable)(({ theme }) => ({
  minHeight: 300,
  width: "100%",
  padding: " 8px 24px",
  position: "relative",
  outline: "none",
  color: "#000",
}));

export const toggleButtonGroupStyles: SxProps = {
  "& .MuiToggleButtonGroup-grouped": {
    margin: "4px",
    border: 0,
    borderRadius: "4px",
    "&.Mui-disabled": {
      border: 0,
    },
  },
  "& .MuiToggleButtonGroup-middleButton, & .MuiToggleButtonGroup-lastButton": {
    marginLeft: -1,
    borderLeftColor: `rgba(0, 0, 0, 0)`,
  },
};

export const editorTheme = {
  ltr: "ltr",
  rtl: "rtl",
  paragraph: "editor-paragraph",
  heading: {
    h1: "editor-title",
    h2: "editor-heading",
    h3: "editor-caption",
    h4: "editor-paragraph",
    h5: "editor-paragraph",
    h6: "editor-paragraph",
  },
  list: {
    nested: {
      listitem: "editor-nested-list-item",
    },
    ol: "editor-list-ol",
    ul: "editor-list-ul",
    listitem: "editor-list-item",
  },
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
    underline: "editor-text-underline",
  },
};

export const editorStyles = {
  ".editor-title": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 700,
    fontStyle: "normal",
    fontSize: "1.5em",
  },
  ".editor-heading": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "1.25em",
  },
  ".editor-paragraph": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "1em",
  },
  ".editor-caption": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "0.75em",
  },
  ".editor-link": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 400,
    fontStyle: "normal",
    color: "rgb(0, 0, 255)",
  },
  ".editor-text-bold": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 700,
    fontStyle: "normal",
  },
  ".editor-text-italic": {
    fontFamily: '"Merriweather", serif',
    fontWeight: 400,
    fontStyle: "italic",
  },
  ".editor-text-underline": {
    textDecorationLine: "underline",
    textDecorationColor: "#000",
    textDecorationThickness: "2px",
    textDecorationStyle: "solid",
  },
  ".editor-nested-list-item": {
    marginBottom: "0.5em",
    lineHeight: 1.5,
  },
  ".editor-list-ul": {
    listStyleType: "disc",
    margin: "1em 0",
    paddingLeft: "1.5em",
  },
  ".editor-list-ol": {
    listStyleType: "decimal",
    margin: "1em 0",
    paddingLeft: "1.5em",
  },
  ".editor-list-item": {
    marginBottom: "0.5em",
    lineHeight: 1.5,
    fontFamily: '"Merriweather", serif',
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "1em",
  },
};
